import React, { useCallback } from "react";
import "./Auth.css";
import Slider from "react-slick";
import Banner1 from "custom/assets/landing/splash_2.webp";
import Banner2 from "custom/assets/landing/splash_3.webp";
import Banner3 from "custom/assets/landing/splash_4.webp";
import Banner4 from "custom/assets/landing/splash_5.webp";
import Red from "custom/assets/landing/splash-primary-banner.png";
import Orange from "custom/assets/landing/splash-secondary-banner.png";
import { LANDING_AUTH_LAYOUT_KEYS } from "../../utils/translation-constants";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import config from "custom/config/environment";
import { setAppLanguage } from "../../store/actions/app.actions";
import i18next from "i18next";
import { getLanguageSelector } from "../../store/selectors/app.selector";

const settings = {
  dots: false,
  infinite: true,
  speed: 1000,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  autoplay: true,
};

const bannerList = [
  {
    img: Banner3,
  },
  {
    img: Banner1,
  },
  {
    img: Banner2,
  },

  {
    img: Banner4,
  },
];

export default function AuthSlideLayout({ children }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const selectedLng = useSelector(getLanguageSelector);

  const handleLanguage = useCallback((e) => {
    try {
      const { value } = e.target;
      dispatch(setAppLanguage(value));
      i18next.changeLanguage(value);
    } catch (err) {}
  }, []);

  return (
    <div className="row auth-layout-section" style={{ overflow: "auto" }}>
      <div
        className="col-xs-12 col-sm-5 col-md-5 col-xl-5 col-lg-5"
        style={{ height: "100vh" }}
      >
        {config.LANGUAGE_SELECTION && (
          <div className="language-selection">
            <select
              onChange={handleLanguage}
              value={selectedLng}
              placeholder="Choose Language"
            >
              {config.LANGUAGE_LIST.map((option, index) => (
                <option value={option} key={index}>
                  {option.toLocaleUpperCase()}
                </option>
              ))}
            </select>
          </div>
        )}
        <div className="auth-render-section h-100 d-flex flex-column">
          <div className="text-center">
            <div className="auth-logo"></div>
          </div>
          <div>{children}</div>

          <div></div>
        </div>
      </div>
      <div className="col-7 oval d-none d-sm-block d-md-block d-xl-block d-lg-block">
        <div
          className=""
          style={{
            height: "100vh",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <div className="image-render">
            <p className="subtitle2 new-design-text-color">
              {t(LANDING_AUTH_LAYOUT_KEYS.TITLE)}
            </p>
            <div>
              <Slider {...settings} className="slick-slider">
                {bannerList.map((b, i) => (
                  <div key={i} className="">
                    <div>
                      <img
                        src={b.img}
                        alt=""
                        style={{ height: "80vh", borderRadius: 20 }}
                        width="400px"
                      />
                    </div>
                  </div>
                ))}
              </Slider>
            </div>

            <img src={Red} alt="" className="red" />
            <img src={Orange} alt="" className="orange" />
          </div>
        </div>
      </div>
    </div>
  );
}
